import axios from 'axios';
import { showAlert } from './alerts';

export const newsLetterRequest = async (email, turnstileToken) => {
    // const serverBaseDomain = "http://localhost:3000";
    const serverBaseDomain = "https://cserver.zirveextrusion.net";

    if (!turnstileToken || typeof turnstileToken !== "string" || turnstileToken.length > 2048) {
      showAlert('error', 'Please complete the security verification');
      return;
    }

    var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!filter.test(email)) {
      showAlert('error', 'invalid email');
      return;
    }
 
    try {
      const res = await axios({
        method: 'POST',
        url: `${serverBaseDomain}/front/api/newsletter`,
        data: { email, turnstileToken }
      });
      if (res.data.status) {
        showAlert('success', res.data.message);
        if (window.turnstile) {
          window.turnstile.reset();
        }
      }
    } catch (err) {
      showAlert('error', err.response.data.message);
      if (window.turnstile) {
        window.turnstile.reset();
      }
    }
};